<section class="container sign-container login-container" id="logIn" [ngClass]="{themeSignInContainer: themeService.theme !='default'}">
	<img class="sign-in-background" *ngIf="themeService.theme != 'weightmans'" src="../../../assets/img/{{ themeService.theme }}/zp-lg-background.png" alt="" />
	<img *ngIf="themeService.theme == 'bluecoat'" class="bluecoat-login-right-logo" src="../../../assets/img/bluecoat/icon-logo.png" alt="" />
	<section class="navbar-brand">
		<img src="../../../assets/img/{{ themeService.theme }}/{{ themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo' }}.png" alt="" width="125px"
			[ngClass]="{ 'img-theme-nav-bar': themeService.theme == 'life-file' }" />
	</section>
	<!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
	<section class="container" *ngIf="!doMFA">
		<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" [ngClass]="{'theme-shadow': isDefaultTheme == false, 'bluecoat-login-card': themeService.theme == 'bluecoat'}">
			<h1 *ngIf="themeService.theme != 'NWRTheme'" class="serif-title">Log In</h1>
			<h1 *ngIf="themeService.theme == 'NWRTheme'" class="serif-title" style="color: #000 !important-password">Log-in to your vault</h1>
			<section class="sign-get-info">
				<section class="form-group">
					<input type="email" class="form-control" id="logInEmail" placeholder="Enter email" required
						formControlName="userName" [ngClass]="{signInput: themeService.theme != 'default'}" [ngClass]="{ 'is-invalid': submitted && f.userName.errors }" />
					<div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
						<div *ngIf="f.userName.errors.required">Email is required</div>
						<div *ngIf="f.userName.errors.email">
							Email must be a valid email address
						</div>
					</div>
				</section>
				<section class="form-group caps-lock-section">
					<input [type]="statusPassword ? 'text' : 'password'" class="form-control" id="password"
						placeholder="Enter password" required formControlName="password"
						[ngClass]="{signInput: themeService.theme != 'default'}" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" (capsLock)="capsOn = $event"/>
					<i class="caps-lock-icon fa fas fa-eye" (click)="statusPassword = !statusPassword"></i>
					<i class="caps-lock-icon fa fas fa-eye-slash" (click)="statusPassword = !statusPassword"
						[ngClass]="statusPassword ? 'eye-slash' : ''"></i>
					<div *ngIf="capsOn" class="warning-caps-locked">Caps Locked</div>
					<div *ngIf="submitted && f.password.errors" class="invalid-feedback">
						<div *ngIf="f.password.errors.required">Password is required</div>
					</div>
				</section>
				<section class="form-group forgot-info">
					<a [routerLink]="['/resetpasswordemail']">Forgot password?</a>
				</section>
				<section class="submit-info">
					<input *ngIf="themeService.theme != 'NWRTheme'" type="submit" class="form-control btn btn-primary primary-default-btn" value="Log In"
						[disabled]="disabled || disableSignIn"/>
					<input *ngIf="themeService.theme == 'NWRTheme'" type="submit" class="form-control btn btn-primary primary-default-btn" value="Log In"
						[disabled]="disabled || disableSignIn" style="background: #000 !important;">
					<div class="notification-bubble-container">
						<app-notification-bubble></app-notification-bubble>
					</div>
					<div *ngIf="loginFail">
						<div>Login Failure</div>
					</div>
				</section>
				<!-- <div class="sign-account sign-account-mobile" [routerLink]="['/sign-up']">Don't have an account? Sign Up </div> -->
			</section>
		</form>
	</section>
	<section class="container" *ngIf="doMFA" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<app-mfa *ngIf="isEmail || !isMobile" [title]="'Multi-Factor Authentication'"
			[text]="'For your security, we have sent an authentication code to your email. Please retrieve it and enter it below to continue. You may have to check your junk inbox.'"
			[textBtn]="'Continue'" [loginForm]="loginForm" [myUser]="myUser" [id]="id" [MFAFail]="MFAFail"
			[username]="loginForm.controls['userName'].value.toLowerCase()" (submitEvent)="onSubmit()"
			(sendToLocationEvent)="sendToLocation($event)" (disableSignInBtnEvent)="disableSignInBtn($event)">
		</app-mfa>

		<app-mfa *ngIf="isMobile" [title]="'Multi-Factor Authentication'"
			[text]="'We have sent you a code via SMS. Enter it below to verify your mobile number.'" [id]="id"
			[textBtn]="'Verify'" [myUser]="myUser" [MFAFail]="MFAFail"
			[loginForm]="loginForm" [username]="loginForm.controls['userName'].value.toLowerCase()"
			(submitEvent)="onSubmit()" (sendToLocationEvent)="sendToLocation($event)"
			[isLogIn]="'isLogIn'">
		</app-mfa>
	</section>
</section>
<div class="loading-overlay" *ngIf="loader">
	<app-loader></app-loader>
</div>
<app-footer></app-footer>